import React, { useState, useEffect } from "react";
import "./Loading.scss";
import loadingGif from "../../../images/loading.gif";

const Loading = ({ name }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <img src={loadingGif} alt="Loading..." className="loading-gif" />
        <p>{name}</p>
      </div>
    </div>
  );
};

export default Loading;
